import React, { Component } from "react";
import InfoDialogBaseView from "../../../../components/InfoDialogBase/InfoDialogBaseView";
import InfoDialogTitleView from "../../../../components/InfoDialogBase/InfoDialogTitle/InfoDialogTitleView";
import TranslationView from "../../../../../../components/translation/TranslationView";
import InfoDialogSubtitleView from "../../../../components/InfoDialogBase/InfoDialogSubtitle/InfoDialogSubtitleView";
import InfoDialogTextView from "../../../../components/InfoDialogBase/InfoDialogText/InfoDialogTextView";

export default class CheckEditConfirmationView extends Component {

    render() {
        return (
            <InfoDialogBaseView>
                <InfoDialogTitleView>
                    <TranslationView style={{ fontWeight: 300 }}>
                        checkEditConfirmation
                    </TranslationView>
                </InfoDialogTitleView>

                <InfoDialogSubtitleView>
                    <TranslationView style={{ fontWeight: 500 }}>
                        requestSent
                    </TranslationView>
                </InfoDialogSubtitleView>

                <InfoDialogTextView>
                    <TranslationView style={{ fontWeight: 300 }}>
                        mailWhenEditComplete
                    </TranslationView>
                </InfoDialogTextView>
            </InfoDialogBaseView>
        );
    }
}